import { cn as l } from "../../../lib/utils.es.js";
import { jsx as i } from "react/jsx-runtime";
var e = ({ children: a, className: x, wide: m, containerClassName: r, ...b }) => /* @__PURE__ */ i("div", {
  className: l(r, "lib:@container"),
  children: /* @__PURE__ */ i("div", {
    className: l(x, "lib:mx-auto lib:w-full lib:@2xl:px-25 lib:@md:px-8 lib:@sm:px-8 lib:@xl:px-16 lib:px-4", m && "lib:@xl:max-w-9xl"),
    ...b,
    children: a
  })
});
e.displayName = "Container";
export {
  e as default
};
